import store from '../store';

/**
 * Get the current locale from the Redux store
 * @returns {string} Current locale (e.g., 'en', 'ru', 'lt')
 */
export const getCurrentLocale = () => {
  const user = store.getState().current_user;
  return user.locale || 'en'; // fallback to 'en' if not set
};

/**
 * Build a URL with locale prefix
 * @param {string} path - The path without locale (e.g., '/api/standings')
 * @returns {string} Path with locale prefix (e.g., '/en/api/standings')
 */
export const buildLocalizedUrl = (path) => {
  const locale = getCurrentLocale();
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `/${locale}/${cleanPath}`;
};
